import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Utility } from '../../../common/utility';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA, MdOptionSelectionChange } from '@angular/material';
import { MomentModule } from 'angular2-moment';
import { AppConstants } from '../../../shared/constants/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultationProcessService } from '../consultation-process.service';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { AppMessages } from '../../../shared/constants/messages';
import { PrescriptionsModule } from './select-prescriptions.service';
import { PrescriptionsModel } from '../../../models/consultation-process/prescription-selection.model';
import { EditPrescriptionPopupComponent } from './edit-prescription-popup.component';
import { FormControl } from '@angular/forms';

@Component({
    templateUrl: 'select-prescriptions.component.html',
    providers: [PrescriptionsModule],
    styles: [
        `md-spinner {
      width: 24px;
      height: 24px;
      margin: 5px 10px 0px 0px;
      top: 0;
      right: 0;
      position: absolute;
    }`,
        `.form-group {
      width: 100%;
    }`,
        `.form-select, .mat-option{
        font-size: 14px
    }`
    ]
})

export class SelectPrescriptionComponent extends BaseConsultationComponent implements OnInit, OnDestroy {
    public klass = 'selectPrescription';
    public categorySelected: any = null;
    public categories: Array<any> = [];
    public prescriptions: Array<PrescriptionsModel> = [];
    public prescriptionToAdd: Array<PrescriptionsModel> = [];
    public prescriptionSelected: Array<any> = [];
    public prescriptionToRemove: Array<any> = [];
    public appConstants = AppConstants;
    selectedSearchPrescription: PrescriptionsModel;
    searchList: Array<PrescriptionsModel>;
    quickSearchCtrl: FormControl;
    isSearching = false;

    constructor(public dialogService: DialogService,
        public consultationProcessService: ConsultationProcessService,
        public router: Router,
        public activeRouter: ActivatedRoute,
        public utility: Utility,
        public prescriptionsModule: PrescriptionsModule) {
        super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.SelectPrescriptions);
        this.quickSearchCtrl = new FormControl();
        this.quickSearchCtrl.valueChanges.subscribe(keyword => {
            if (keyword) {
                if (keyword.length > 2) {
                    if (this.isSearching) { return; }
                    this.isSearching = true;
                    this.prescriptionsModule.quickSearchPrescriptions(keyword, false).subscribe(result => {
                        this.isSearching = false;
                        if (result) {
                            const data = result.json();
                            const tempArr = <Array<any>>data;
                            this.searchList = [];
                            if (this.prescriptionSelected) {
                                let i = 0;
                                const lens = tempArr.length;
                                while (i < lens) {
                                    const index = this.prescriptionSelected.findIndex(x =>
                                        x.centrePrescriptionId === tempArr[i].centrePrescriptionId);
                                    if (index < 0) {
                                        this.searchList = this.searchList.concat(tempArr[i]);
                                    }
                                    i++;
                                }
                            } else {
                                this.searchList = tempArr;
                            }
                        }
                    }, error => { this.isSearching = false; });
                }
            }
        });
    }

    ngOnInit() {
        /*  if (this.activeRouter.snapshot.queryParams['listPrescriptionSelected']) {
           this.prescriptionSelected = this.activeRouter.snapshot.queryParams['listPrescriptionSelected'];
         } */
        this.prescriptionsModule.getConsultationPrescriptions(this.filterParam.id).subscribe(
            (result) => {
                if (result) {
                    this.prescriptionSelected = result.json();
                    this.prescriptionsModule.getPrescriptionsCategories().subscribe(
                        (res) => {
                            if (res) {
                                const data = res.json();
                                this.categories = data;
                                this.categorySelected = this.categories[
                                    this.categories.findIndex(item => item.isSelected === true)] || this.categories[0];
                                this.getPrescription();
                            }
                        }
                    );
                }
            }
        );

      this.initTripInfo();

    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }

    //  Filter prescription related to selected category
    getPrescription() {
        if (this.categorySelected) {
            this.prescriptionsModule.getPrescriptions(this.categorySelected.id).subscribe(
                (result) => {
                    if (result) {
                        const data = result.json();
                        this.prescriptions = data;
                        if (this.prescriptionToAdd.length > 0) {
                            this.prescriptionToAdd.forEach(pre => {
                                const index = this.prescriptions.findIndex(x => x.centrePrescriptionId === pre.centrePrescriptionId);
                                if (index > -1) {
                                    this.prescriptions[index]['checked'] = true;
                                }
                            });
                        }
                        this.checkPrescriptionsCategory();
                    }
                }
            );
        }
    }

    checkPrescriptionsCategory() {
        this.prescriptionSelected.forEach(prescription => {
            const index = this.prescriptions.findIndex(item => item.centrePrescriptionId === prescription.centrePrescriptionId);
            if (index >= 0) {
                this.prescriptions.splice(index, 1);
            }
        });
    }

    // behavior when click button add
    selectPrescription() {
        this.prescriptionToAdd.forEach(item => {
            this.prescriptionSelected.push(item);
        });
        this.resetPrescriptionToAdd();
    }

    // behavior when click button remove
    removePrescription() {
        this.prescriptionToRemove.forEach(item => {
            this.prescriptionSelected.splice(this.prescriptionSelected.findIndex(prescription =>
                prescription.centrePrescriptionId === item.centrePrescriptionId), 1);
        });
        this.resetPrescriptionToRemove();
        this.getPrescription();
    }

    // checking if button add can be activated
    onCheckButtonAdd() {
        if (this.prescriptionToAdd.length < 1) {
            return true;
        }
        return false;
    }

    // checking if button remove can be activated
    onCheckButtonRemove() {
        if (this.prescriptionToRemove.length < 1) {
            return true;
        }
        return false;
    }

    // reset temp array for prescriptions to add
    resetPrescriptionToAdd() {
        this.getPrescription();
        this.prescriptionToAdd = [];
    }

    // reset temp array for prescriptions to remove
    resetPrescriptionToRemove() {
        this.prescriptionToRemove = [];
    }

    // create temp array for prescriptions to add
    onCheckAddList(event, prescription) {
        const index = this.prescriptionToAdd.findIndex(item => item.centrePrescriptionId === prescription.centrePrescriptionId);
        prescription['checked'] = event.checked;
        if (event.checked && index === -1) {
            this.prescriptionToAdd.push(prescription);
        } else if (index >= 0) {
            this.prescriptionToAdd.splice(index, 1);
        }
        this.onCheckButtonAdd();
    }

    // create temp array for prescriptions to remove
    onCheckRemoveList(event, prescription) {
        const index = this.prescriptionToRemove.findIndex(item => item.centrePrescriptionId === prescription.centrePrescriptionId);
        if (event.checked && index === -1) {
            this.prescriptionToRemove.push(prescription);
        } else if (index >= 0) {
            this.prescriptionToRemove.splice(index, 1);
        }
        this.onCheckButtonRemove();
    }

    // open edit prescription popup
    openEditPrescriptionDialog(prescription) {
        this.dialogService.openComponentDialog(EditPrescriptionPopupComponent, prescription, {
            'width': '600px'
        }).subscribe(result => {
            if (result) {
                if (result.type === 'week') {
                    prescription.isWeekType = true;
                } else {
                    prescription.isWeekType = false;
                }
                prescription.quantity = result.quantity;
            }
        });
    }

    /**
      * over write in base consultation submit consultation step data
      */
    submitData() {
        this.prescriptionsModule.updatePrescriptions(this.filterParam.id, this.prescriptionSelected, this.isMoveNextStep).subscribe(
            (result) => {
                if (result) {
                    // call API success
                    this.navigateAction();
                }
            }
        );

    }

    addPrescriptionFromSearch(event: MdOptionSelectionChange, prescription: any) {
        if (prescription) {
            const index = this.prescriptionSelected.findIndex(x => x.centrePrescriptionId === prescription.centrePrescriptionId);
            if (this.prescriptionToAdd.length > 0) {
                const temp = this.prescriptionToAdd.findIndex(x => x.centrePrescriptionId === prescription.centrePrescriptionId);
                if (temp > -1) {
                    this.prescriptionToAdd.splice(temp, 1);
                }
            }
            if (index < 0) {
                this.prescriptionSelected.push(prescription);
                this.getPrescription();
            }
            event.source.value = '';
            this.searchList = [];
        }
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/select-prescriptions/select-prescriptions.component.ts